module.exports = __webpack_public_path__ + "static/media/AF.6c312678.pdf";